import StoreSelect from './StoreSelect'

export default StoreSelect
